<!--
Copyright (c) 2020 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details.
-->
<template>
  <div id="app">
    <ThemeInjector
      :theme="theme"
      v-if="theme !== null" />
    <div
      id="appContentWrapper"
      class="h-100">
      <Transition
        name="fade"
        mode="out-in">
        <RouterView
          :logo="logo"
          :key="$route.fullPath" />
      </Transition>
    </div>
    <!-- Application View -->
    <notifications
      position="bottom left"
      width="320"
      :duration="4000">
      <template v-slot:body="props">
        <FrAlert
          :variant="props.item.type"
          show>
          {{ props.item.text }}
        </FrAlert>
      </template>
    </notifications>
  </div>
</template>

<script>
import Alert from '@forgerock/platform-shared/src/components/Alert/';
import ThemeInjector from '@forgerock/platform-shared/src/components/ThemeInjector/';
import RestMixin from '@forgerock/platform-shared/src/mixins/RestMixin';
import { datadogRum } from '@datadog/browser-rum' 
import './scss/main.scss';

export default {
  name: 'App',
  components: {
    FrAlert: Alert,
    ThemeInjector,
  },
  mixins: [
    RestMixin,
  ],
  data() {
    return {
      logo: require('@forgerock/platform-shared/src/assets/images/themes/default/calabrio-logo.svg'),
      theme: null,
    };
  },
  created() {
    // Note: FedRAMP diff in code, use the other project
    const realmTag = process.env.VUE_APP_REALM_TAG
    const regionTag = process.env.VUE_APP_AWS_REGION
    const appId = process.env.VUE_APP_APPLICATION_ID
    const clientToken = process.env.VUE_APP_CLIENT_TOKEN
    const envTag = process.env.VUE_APP_ENV_TAG
    const initDatadogRum = () => {
      datadogRum.init({
          applicationId: appId,
          clientToken:  clientToken,
          site: 'datadoghq.com',
          service: 'ui',
          env: envTag,
          version: process.env.VUE_APP_GIT_HASH,
          sampleRate: 100,
          trackInteractions: true,
          trackViewsManually: true,
          trackSessionAcrossSubdomains: true,
          silentMultipleInit: true,
          trackFrustrations: true,
          // TODO 0 replays for now - requires CSP configuration
          sessionReplaySampleRate: 0,
        });
        
        datadogRum.addRumGlobalContext('realm', realmTag)
        datadogRum.addRumGlobalContext('region', regionTag)
        // TODO later date - localhost stuff (proxy env or show localhost (add new api?))
       datadogRum.setUser({
          authMethod: 'fr',
        })
        datadogRum.startView({
          name: '/iam',
        })
    }
    // Turn off datadog for now
    // initDatadogRum()
    // Clear all datadog rum data
    datadogRum.clearGlobalContext()
    datadogRum.clearUser()
    datadogRum.stopSession()
    this.theme = null
  },
};
</script>
